import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { navigateReport } from '../../Common/navigation';

export default class PPD_Data extends Component {
	constructor(props) {
		super(props);
		// let owner_settings = this.props.receiver.getString("owner_settings");
		// let tenant_settings = this.props.receiver.getString("tenant_settings");
		// let unit_price_settings = this.props.receiver.getString("unit_price_settings");
		// let bill_settings = this.props.receiver.getString("bill_settings");
		let ppd_data_analysis = this.props.receiver.getString("ppd_data_analysis");
		let export_ppd = this.props.receiver.getString("export_ppd");
		this.arr = [ppd_data_analysis];

		if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			this.arr.push(export_ppd);
		}
	}

	//Response from controller - loading all tenants information
	rcvLoadTenant(tenant_info) {
		window.app.hideLoading();
		if (this.navigation == "bill_settings") {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			this.props.content_handler('Bill_Settings', { tenant_info: tenant_info == null ? {} : tenant_info });
		} else {
			window.app.content_area.current.switch_content.current.handleHideBottomMenu();
			this.props.content_handler('Tenant_Settings', { tenant_info: tenant_info == null ? {} : tenant_info });
		}
	}

	//Response from controller - loading owner information
	rcvLoadOwnerInfo(owner_info) {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Owner_Settings', { owner_info: owner_info == null ? {} : owner_info });
	}

	//Response from controller - loading price information
	rcvLoadPriceInfo = (price_info) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Unit_Price_Settings', { price_info: price_info == null ? {} : price_info });
	}

	//Have to change
	handlePrevious = () => {
		// Redirect back to reports instead of system
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		navigateReport("null");
	}

	accessSettings = (index) => {
		window.app.showLoading();
		switch (index) {
			// case 0:
			// 	// Owner Settings
			// 	this.props.receiver.loadOwnerInfo();
			// 	break;
			// case 1:
			// 	// Tenant Settings
			// 	this.navigation = "tenant_settings";
			// 	this.props.receiver.loadTenant();
			// 	break;
			// case 2:
			// 	// Unit Price Settings
			// 	this.props.receiver.loadPriceInfo();
			// 	break;
			// case 3:
			// 	// Bill Settings
			// 	this.navigation = "bill_settings";
			// 	this.props.receiver.loadTenant();
			// 	break;
			case 0:
				//PPD Data Analysis
				window.app.hideLoading();
				window.app.content_area.current.switch_content.current.handleShowBottomControls();
				this.props.content_handler('PPD_Data_Analysis');
				break;
			case 1:
				// Export PPD
				window.app.hideLoading();
				window.app.content_area.current.switch_content.current.handleShowBottomControls();
				this.props.content_handler('Export_PPD');
				break;
		}
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			width: '100%',
			color: 'white',
			fontFamily: "system-ui, -apple-system, -apple-system-font, 'Segoe UI', 'Roboto', sans-serif",
			height: this.props.height,
		}

		let container_style = {
			paddingLeft: 20,
			paddingRight: 20,
			justifyContent: 'center',
			alignItems: 'center',
			//height: '700px',
			height: this.props.height - 50,
			overflow: 'auto',
			paddingTop: '10px'
		}

		let billing_container = {
			cursor: 'pointer',
			backgroundColor: '#f9f9f9',
			borderRadius: 10,
			maxWidth: '100%',
			width: 'auto',
			alignItems: 'center',
			justifyContent: 'left',
			position: 'relative',
			display: 'flex',
			marginTop: 10,
			marginBottom: 10,
			padding: 10
		}

		let biling_info_container = {
			marginLeft: 5,
			maxWidth: '60%',
			width: '60%',
			textAlign: 'left',
		}

		let billing_options_name = {
			fontSize: 16,
			color: 'black',
			fontWeight: 'bold',
			padding: 0,
			margin: 5,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		}

		return (
			<div>

				<div style={main_content_style} className='slideInDown'>

					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('ppd_data_analysis')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					{/* List of settings */}
					<div style={container_style}>
						<div id="deviceContainer" style={{ paddingBottom: '80px' }}>
							{this.arr.map((billing_options, index) => {
								return (
									<div style={billing_container} id={index} onClick={() => { this.accessSettings(index) }}>
										<div style={biling_info_container}>
											<p style={billing_options_name}>{billing_options}</p>
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}